import { OptionItem } from '@kuiper/ibusiness-core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Contract } from './contract.model';
import { ContractDetails } from './contract-details.model';
import { ApiResponse } from '@kuiper/ibusiness-core';
import { Insight } from '@kuiper/ibusiness-core';

import { ENDPOINTS } from '@kuiper/ibusiness-core';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  private readonly http = inject(HttpClient);

  createContract(payload: any, projectId: string) {
    const url = ENDPOINTS.Application.Contract.Create.replace(
      '{projectId}',
      projectId
    );
    return this.http.post(url, payload);
  }

  getContractById(projectId: string, contractId: string) {
    const url = ENDPOINTS.Application.Contract.GetById.replace(
      '{projectId}',
      projectId
    ).replace('{contractId}', contractId);
    return this.http.get<{ data: ContractDetails }>(url);
  }

  getContractList(
    projectId: number,
    page: number,
    per_page: number,
    filter: string
  ) {
    let params;
    if (filter && filter !== 'all') {
      params = new HttpParams()
        .append('page', page)
        .append('per_page', per_page)
        .append('filters[state]', filter);
    } else {
      params = new HttpParams()
        .append('page', page)
        .append('per_page', per_page);
    }

    params = params.append('filters[exclude_developer]', true);

    const url = ENDPOINTS.Application.Contract.GetList.replace(
      '{projectId}',
      projectId.toString()
    );
    return this.http.get<ApiResponse<Contract>>(url, { params });
  }

  updateContract(payload: any, projectId: string, contractId: string) {
    const url = ENDPOINTS.Application.Contract.Update.replace(
      '{projectId}',
      projectId
    ).replace('{contractId}', contractId);
    return this.http.put(url, payload);
  }

  getContractPaymentInsights(contractId: string) {
    const url = ENDPOINTS.Application.Contract.InvoiceInsights.replace(
      '{contractId}',
      contractId
    );

    return this.http.get<ApiResponse<Insight>>(url);
  }

  getContractChart(contractId: string, chart: string) {
    const url = ENDPOINTS.Application.Contract.InvoiceChart.replace(
      '{contractId}',
      contractId
    ).replace('{chart}', chart);

    return this.http.get<ApiResponse<Insight>>(url);
  }

  getContractDeductionTypes() {
    const url = ENDPOINTS.Application.Contract.ContractDeductionTypes;
    return this.http.get<ApiResponse<OptionItem[]>>(url);
  }

  getDeveloperContract(projectId: number) {
    const url = ENDPOINTS.Application.Contract.DeveloperContract.replace(
      '{projectId}',
      projectId.toString()
    );
    return this.http.get<{ data: ContractDetails }>(url);
  }

  cancelAndRefundContract(projectId: string, contractId: string) {
    const url = ENDPOINTS.Application.Contract.CancelAndRefund.replace(
      '{projectId}',
      projectId.toString()
    ).replace('{contractId}', contractId);
    return this.http.put(url, {});
  }
}
